import { Login } from "@/pages/public/Login";

export const PublicLayout = () => {
  return (
    <div className="text-center">
      <header className=" bg-slate-800 min-h-screen flex flex-col items-center justify-center text-base text-white w-full">
        <Login />
      </header>
    </div>
  );
};
